import { SWRConfiguration } from 'swr';

import { GetVideoOptions, GetVideoFields, GetVideoResult } from '@vimeo/gctl-api/fetchers/video';
import { useGetVideo as useGetVideoGCTL } from '@vimeo/gctl-api/hooks/useVideo';

import { getPasswordHashFromCookie } from './utils';

type UseGetVideoOptions<Fields extends GetVideoFields> = GetVideoOptions<Fields>;

/**
 * useGetUnlockedVideo - Utility hook that wraps around GCTL `useGetVideo` and allows us to send password hash as a parameter for password-protected videos
 */
export function useGetUnlockedVideo<Fields extends GetVideoFields>(
  getOptions: UseGetVideoOptions<Fields> | (() => UseGetVideoOptions<Fields> | null),
  config?: SWRConfiguration<GetVideoResult<Fields>>,
) {
  const defaultOpts = typeof getOptions === 'function' ? getOptions() : getOptions;

  const password = defaultOpts ? getPasswordHashFromCookie(defaultOpts?.where.videoId) : null;

  const opts: UseGetVideoOptions<Fields> | null = defaultOpts
    ? {
        ...defaultOpts,
        query: {
          ...defaultOpts?.query,
          ...(password && { password }),
        },
      }
    : null;

  // @ts-expect-error Permit passing options object with added password cookie
  return useGetVideoGCTL(opts, config);
}
